import type { ReactNode } from "react";

/** Блок карточки результата с заголовком (был `Block` в ResultCardPage). */
export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="grid gap-2 rounded-[var(--radius-ui)] border border-border bg-bg p-3" data-annot={title}>
      <h2 className="text-[13px] font-semibold text-fg">{title}</h2>
      {children}
    </section>
  );
}
